import { ApiError } from "../../api/errors";

/**
 * What an operator is told when an organisation call fails.
 *
 * 🔑 The gateway admits Operator and superadmin logins only (radaccess
 * resource `rosterorg`). A bssadmin, support or reseller login is refused with
 * a 403 it cannot fix by signing in again, so it is told whose login can.
 * An unrecognised refusal shows the server's own words rather than a guess.
 */
export function orgRefusal(e: unknown): string {
  if (!(e instanceof ApiError)) return e instanceof Error ? e.message : String(e);
  if (e.kind === "unauthenticated") return "Your sign-in has expired. Sign out and sign in again.";
  if (e.kind === "forbidden") {
    return `Refused: ${e.message}. Only an Operator or superadmin login may manage organisations and their sponsors.`;
  }
  if (e.status === 409) {
    if (/name is already used/i.test(e.message)) return "An organisation with this name already exists on this hotspot.";
    return e.message;
  }
  if (e.kind === "not-found" && /organisation not found/i.test(e.message)) {
    return "This organisation is not on this hotspot.";
  }
  if (e.kind === "at-capacity") return "The service is busy. Wait a moment and try again.";
  return e.message;
}
